export const NAMESPACE = 'KanBo/Home/layoutPermissions/'
export const SET = NAMESPACE + 'SET'

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET:
      return {
        ...state,
        [action.payload.id]: action.payload.permissionLevel
      }
    default: return state
  }
}

export function set ({ id, permissionLevel }) {
  return {
    type: SET,
    payload: {
      id,
      permissionLevel
    }
  }
}
